import CouponSkeleton from '@/components/vendors/coupon/CouponCard/skeleton';
const CouponSectionSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="h-[368px] box-border py-[18px] px-5 bg-no-repeat bg-center bg-[auto_100%]">
      <div className="flex items-center justify-between pb-[13px]">
        <div className="flex items-center justify-between">
          <div className="w-11 h-11 rounded-700 mr-2.5 bg-surface-200-bg !bg-[30px_auto]"></div>
          <div>
            <div className="h-4 w-[190px] bg-surface-200-bg"></div>
            <div className="h-4 w-[140px] bg-surface-200-bg mt-1"></div>
          </div>
        </div>
        <div>
          <div className="w-6 h-6 rounded-700 mr-2.5 bg-surface-200-bg"></div>
        </div>
      </div>
      <CouponSkeleton className="mb-0" />
    </div>
  );
};

export default CouponSectionSkeleton;
